import { closeOverlayCart } from './overlay-cart';
import { closePopup } from './popup';

const dim = document.querySelector('.js-dim');

dim.addEventListener('click', function() {
    closeOverlayCart();
    closePopup();
});

export function openDim() {
    dim.classList.add('-open');
}

export function closeDim() {
    dim.classList.remove('-open');
}